import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";
import "./plugins/axios";
import "./plugins/vee";
import "./plugins/vuetoastification";
import configs from "@/configs";
import setApiRoutes from "./helpers/setApiRoutes";

import { getPermissions, filters, calendar, errorFunction } from "@/utils";
Vue.filter("dateFilter", filters.dateFilter);
Vue.filter("floatFilter", filters.floatFilter);
Vue.filter("cpfCnpjFilter", filters.cpfCnpjFilter);
Vue.prototype.$calendar = calendar;
Vue.prototype.$fnError = errorFunction;
Vue.prototype.$getPermissions = getPermissions;

// Vue.config.devtools = true
// Vue.config.performance = true

Vue.config.productionTip = false;

const { system, env } = configs;
setApiRoutes(Vue, system, env);

Vue.prototype.$vuetify = vuetify;

import VuePivottable from "../lib/vue-pivottable/src";
import "../lib/vue-pivottable/src/assets/vue-pivottable.css";
Vue.use(VuePivottable);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
